


import { createRouter, createWebHistory } from 'vue-router'

const history = createWebHistory('/') 
const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../pages/Index.vue'),

    },
    
   
    {
        path: '/moreNews',
        name: 'Morenews',
        component: () => import('../pages/moreNews.vue'),
    },
    {
        path: '/newsDetail',
        name: 'NewsDetail',
        component: () => import('../pages/newsDetail.vue'),
    },
    
    {
        path: '/positionProposal',
        name: 'PositionProposal',
        component: () => import('../pages/positionProposal.vue'),
    },
    {
        path:'/concactUs',
        name:'Concactus',
        component:() => import('../pages/concactUs.vue')
    },
    {
        path: '/agreement',
        name: 'Agreement',
        component: () => import('../pages/agreement.vue')
    },
    {
        path: '/privacyPolicy',
        name: 'Privacypolicy',
        component: () => import('../pages/privacyPolicy.vue')
    },

]
const router = createRouter({
    history,
    routes 
})

export default router
